export const BinIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1269_18380)">
        <path
          d="M16.6001 4.60156H3.40015"
          stroke="#4E4E4E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.19995 8.19922V12.9992"
          stroke="#4E4E4E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8 8.19922V12.9992"
          stroke="#4E4E4E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4001 4.60156V16.0016C15.4001 16.1607 15.3369 16.3133 15.2244 16.4258C15.1118 16.5383 14.9592 16.6016 14.8001 16.6016H5.2001C5.04097 16.6016 4.88836 16.5383 4.77583 16.4258C4.66331 16.3133 4.6001 16.1607 4.6001 16.0016V4.60156"
          stroke="#4E4E4E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 4.59922V3.39922C13 3.08096 12.8736 2.77573 12.6485 2.55069C12.4235 2.32565 12.1183 2.19922 11.8 2.19922H8.2C7.88174 2.19922 7.57652 2.32565 7.35147 2.55069C7.12643 2.77573 7 3.08096 7 3.39922V4.59922"
          stroke="#4E4E4E"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1269_18380">
          <rect
            width="19.2"
            height="19.2"
            fill="white"
            transform="translate(0.399902 0.398438)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
